<template>
    <div class="pm ">
<!--        <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>-->
        <el-input style="width: 120px" class="marr4" clearable size="mini" placeholder="名称" v-model="vc_name">
        </el-input>
<!--        <el-select  style="width: 100px"  class="marr4" v-model="i_state" size="mini"  >-->
<!--            <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
<!--            </el-option>-->
<!--        </el-select>-->
        <el-button class="marB10" icon="el-icon-search" circle @click="searchFun " size="mini" ></el-button>
        <el-table class="mrt10" ref="table"  @row-dblclick="chooseRowFun" row-key="wyid"  size="mini" :height="tableHeight" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <!--                    <el-table-column  :selectable="selectable" :reserve-selection="true" align="center" type="selection" width="50px" ></el-table-column>-->
            <!--                    <el-table-column label="序号" align="center" type="index" width="50px"show-overflow-tooltip></el-table-column>-->
            <!--            <el-table-column  align="center" type="selection" width="50px" show-overflow-tooltip></el-table-column>-->
            <el-table-column align="center" label="产品分类名" prop="vc_pztype" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="产品名" prop="vc_pzname" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="规格名" prop="vc_name" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="英文名" prop="vc_ename" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="产地" prop="vc_cd"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="厂家" prop="vc_gykh"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="包装规格" prop="vc_bzstyle"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="包装单位" prop="vc_bzunit"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="转换比率" prop="f_bl"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="计量单位" prop="vc_unit"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="单件净重" prop="f_weight"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="件重单位" prop="vc_djunit"show-overflow-tooltip></el-table-column>


        </el-table>

        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="pageSizes"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>




    </div>

</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "index",
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                currentPage: 1,
                pageSize: 30,
                total:0,
                pageSizes:[30,100,200,300],
                tableData:[],
                tableHeight:0,//列表高度
                baseerp:'',
                cpggVisible:false,
                cpggData:{},
                cpggtitle:'',
                vc_name:'',
                vc_cd:"",
                vc_gykh:'',
                vc_bzstyle:'',
                vc_material:'',
                i_state:1,
                stateList:[{i_id:1,vc_name:'启用'},{i_id:0,vc_name:'未启用'},],
                flagList:[],
                chooseggData:{},
                zycpggList:[],
                zycpggData:{},
                zycpggVisible:false,
                zycpggtitle:'',
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                treespan:4,
                rightspan:20,
                isright:true,//树显示按钮

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.findClassificationAttributes();
            // this.getProductSpecification()
            this.getProductSpecification()


        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            // chooseggFun(val){
            //     this.chooseggData=val
            // },
            chooseRowFun(val){
                this.chooseRow=val
                this.$emit('close',val)
            },
            searchFun(){
                this.currentPage = 1;
                this.getProductSpecification()
            },
            async getProductSpecification(){
                // this.tableData=[]
                this.dataText=this.$t('tips_data_loading_in_progress')

                let param = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_name:this.vc_name,
                    vc_cd:'',
                    vc_gykh:'',
                    vc_bzstyle:'',
                    vc_material:'',
                    isuse:1,
                    i_pzid:0,
                    i_pztypeid:0,
                    i_isprocess:2,


                };
                let res = await API.getProductSpecification(param);
                if (res.code == 1) {
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                    this.tableData.map(t=>{
                        t.wyid=t.i_pztypeid+'-'+t.i_id
                    })
                    // this.pageSizes=this.getPageSizes(this.total);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getProductSpecification();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getProductSpecification();
            },
            getPageSizes(total){
                const max=Math.ceil(total/200);
                return  Array.from({length:max},(_, i)=> 200 * (i+1));
            },

            isRowSelectable(row,index){
                if(this.formData.i_bzid==1){
                    return true
                }else{
                    if(row.i_bzid===this.formData.i_bzid){
                        return true
                    }else{
                        return false
                    }
                }
            },

            selectable(row){
                if(row.i_syncyy_type==2){
                    return true
                }else{
                    return false
                }
            },


        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }

    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table .el-button--text{
            color: #333;
        }
    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
</style>